import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { Modal } from "components/designV2/modal/modal";
import { useTranslation } from "react-i18next";
import {
  TipsWarningModalActions,
  TipsWarningModalContent,
  TipsWarningModalMessage,
} from "../tips.styled";

interface TipsAmountResetWarningModalProps {
  readonly isOpen: boolean;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
}

export const TipsAmountResetWarningModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: TipsAmountResetWarningModalProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      label={t("General.Information")}
      size="compact"
      showCloseButton={false}
      footer={
        <TipsWarningModalActions>
          <SecondaryButton
            label={t("Tips.Cancel")}
            onClick={onCancel}
            size="small"
            type="button"
          />
          <PrimaryButton
            label={t("General.Ok")}
            onClick={onConfirm}
            size="small"
            type="button"
          />
        </TipsWarningModalActions>
      }
    >
      <TipsWarningModalContent>
        <TipsWarningModalMessage>
          {t("CompanyTip.IfYouChangeTipAllAmountsWillReset")}
        </TipsWarningModalMessage>
      </TipsWarningModalContent>
    </Modal>
  );
};
